/**
 * Created by senani on 1/2/19.
 */

import React, {Component} from "react";
import "./OrderTableHeader.css";

import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../../../Site/QuotationForm/InitialQuotationState";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";

const optionsInEN = [
    {text: "Today", value: 1},
    {text: "This Week", value: 2},
    {text: "This Month", value: 3},
    {text: "This Year", value: 4},
    {text: "Date Range", value: 5},
    {text: "All", value: null}
];
const optionsInJP = [
    {text: "今日", value: 1},
    {text: "今週", value: 2},
    {text: "今月", value: 3},
    {text: "今年", value: 4},
    {text: "期間", value: 5},
    {text: "全て", value: null}
];

const FromToDateToggle = (props) => {
    return (
        <div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label">
                    <FormattedMessage id="app.order.history.date.from"
                                      defaultMessage="From"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input"
                       name="from" type="date"/>
            </div>
            <div className="col-md-1">&nbsp;</div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label no-padding">
                    <FormattedMessage id="app.order.history.date.to"
                                      defaultMessage="To"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input"
                       name="to" type="date"/>
            </div>
        </div>
    )
};

class OrderTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            period: null,
            lang: "ja",
            allOrderTotal: 0
        };

        this.handlePeriodChange = this.handlePeriodChange.bind(this);
        this.getAllOrdersTotal = this.getAllOrdersTotal.bind(this);
    }

    // componentDidMount() {
    //     document.getElementById("completed").click();
    //     document.getElementById("pending").click();
    //     document.getElementById("progress").click();
    // }

    getAllOrdersTotal = () => {
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/total-all')
            .then((res) => {
                this.setState({
                    allOrderTotal: res.data,
                });
                // console.log("rr ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount() {
        let lang = localStorage.getItem("setLang");
        this.setState({
            lang
        });

        this.getAllOrdersTotal();
    }

    handlePeriodChange = (periodChangeEvent) => {
        if (periodChangeEvent.target.name == "period-input") {
            this.setState({
                period: periodChangeEvent.target.value
            }, () => {
                if (this.state.period === "All") {
                    this.props.getAllOrders(0, 5);
                }
            });
        }
        if (periodChangeEvent.target.name == "from") {
            this.props.setSearchTimeRange("from", periodChangeEvent.target.value);
        } else if (periodChangeEvent.target.name == "to") {
            this.props.setSearchTimeRange("to", periodChangeEvent.target.value);
        } else {
            this.props.setSearchTimePeriod(periodChangeEvent.target.value);
        }
    };

    render() {
        let lang = InitialQuotationState.lang;
        let ordertotal=0;

        // console.log("RENDERING....");
        return (
            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-1 no-padding">
                        <div className="all-order-header-label">
                            <FormattedMessage id="app.order.history.header.status"
                                              defaultMessage="Status:"
                                              description=""/></div>
                    </div>
                    <div className="col-md-10 no-padding-right">
                        {/*<select name="status-input" className=" form-control all-order-header-search-input">*/}
                        {/*<option value={null}>All</option>*/}
                        {/*<option value={1}>Pending</option>*/}
                        {/*<option value={2}>In Progress</option>*/}
                        {/*<option value={3}>Completed</option>*/}
                        {/*</select>*/}

                        <div className="row">
                            {/*<div className="col-md-1">*/}
                            {/*<input name="all" type="checkbox" value={0} onChange={this.props.setSearchStatus}/>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-2">*/}
                            {/*<FormattedMessage id="app.order.history.header.status.all"*/}
                            {/*defaultMessage="All"*/}
                            {/*description=""/>*/}
                            {/*</div>*/}
                            <div className="col-md-1">
                                <input name="pending" defaultChecked={true} id="pending" type="checkbox" value={1}
                                       onChange={this.props.setSearchStatus}/>
                            </div>
                            <div className="col-md-2">
                                <FormattedMessage id="app.order.history.header.status.pending"
                                                  defaultMessage="Pending"
                                                  description=""/>
                            </div>
                            <div className="col-md-1">
                                <input name="progress" defaultChecked={true} id="progress" type="checkbox" value={2}
                                       onChange={this.props.setSearchStatus}/>
                            </div>
                            <div className="col-md-2">
                                <FormattedMessage id="app.order.history.header.status.inprogress"
                                                  defaultMessage="InProgress"
                                                  description=""/>
                            </div>
                            <div className="col-md-1">
                                <input name="completed" defaultChecked={true} id="completed" type="checkbox" value={3}
                                       onChange={this.props.setSearchStatus}/>
                            </div>
                            <div className="col-md-2">
                                <FormattedMessage id="app.order.history.header.status.completed"
                                                  defaultMessage="Completed"
                                                  description=""/>
                            </div>
                            <div className="col-md-3"></div>
                        </div>
                    </div>


                </div>
                <div className="col-md-12">&nbsp;</div>
                <div className="row">

                    <div className="col-md-1 no-padding">
                        <div className="all-order-header-label">
                            <FormattedMessage id="app.order.history.header.date-period"
                                              defaultMessage="Date Period"
                                              description=""/>
                        </div>
                    </div>
                    <div className="col-md-2 no-padding-right">
                        <select name="period-input" onChange={this.handlePeriodChange}
                                className="form-control all-order-header-search-input">
                            {/*<option value={1}>Today</option>*/}
                            {/*<option value={2}>This Week</option>*/}
                            {/*<option value={3}>This Month</option>*/}
                            {/*<option value={4}>This Year</option>*/}
                            {/*<option value={5}>Date Range</option>*/}
                            {/*<option value={null}>All</option>*/}
                            {lang == "ja" ?
                                optionsInJP.map((optionJA) => {
                                    return <option value={optionJA.value}>{optionJA.text}</option>
                                }) :

                                optionsInEN.map((optionEN) => {
                                    return <option value={optionEN.value}>{optionEN.text}</option>
                                })
                            }
                        </select>
                    </div>

                    <div className="col-md-1">&nbsp;</div>
                    {this.state.period == 5 ? <FromToDateToggle
                        handlePeriodChange={this.handlePeriodChange}
                    /> : ""}
                </div>

                <br/>
                <div>
                    <div className="row">
                        <label> <FormattedMessage id="app.admin.all.order.table.all.order.total"
                                                  defaultMessage="Total of All Orders:"
                                                  description=""/>
                            <span>&nbsp;¥
                                {this.props.orders.map(orders => {
                                    ordertotal=ordertotal+orders.orderTotal;

                                })}
                                {ordertotal}
                            </span>
                        </label><br/>
                        <label><FormattedMessage id="app.admin.all.order.table.all.order.cost"
                                                 defaultMessage="Cost of All Orders: "
                                                 description=""/>
                            <span>&nbsp;
                                {this.state.allOrderCost}</span>
                        </label><br/>
                    </div>
                    <hr/>
                </div>

                <div className="row">
                    <div className="all-order-table-header">
                        {/*<hr/>*/}
                        {/*<div className="col-md-1">#</div>*/}
                        <div className="col-md-1">
                            <FormattedMessage id="app.admin.all.order.table.id"
                                              defaultMessage="Order Id"
                                              description=""/>
                        </div>
                        <div className="col-md-2">
                            <FormattedMessage id="app.admin.all.order.table.date"
                                              defaultMessage="Order Date"
                                              description=""/>
                        </div>
                        {/*<div className="col-md-2 no-padding-left no-margin">*/}
                        {/*<FormattedMessage id="app.admin.all.order.table.customer-name"*/}
                        {/*defaultMessage="Customer Name"*/}
                        {/*description=""/>*/}
                        {/*</div>*/}
                        <div className="col-md-1">
                            <FormattedMessage id="app.admin.all.order.table.shipping-method"
                                              defaultMessage="Shipping Method"
                                              description=""/>
                        </div>
                        {/*<div className="col-md-2 no-padding-left no-margin">*/}
                        {/*<FormattedMessage id="app.admin.all.order.table.billing.address"*/}
                        {/*defaultMessage="Billing Address"*/}
                        {/*description=""/>*/}
                        {/*</div>*/}
                        <div className="col-md-2 text-center">
                            <FormattedMessage id="app.admin.all.order.table.order-total"
                                              defaultMessage="Order Total"
                                              description=""/> &#165;
                        </div>

                        <div className="col-md-2 text-center">
                            <FormattedMessage id="app.admin.all.order.table.order-cost"
                                              defaultMessage="Order Cost"
                                              description=""/> &#0036;
                        </div>

                        <div className="col-md-2">
                            <div className="order-status-column">
                                <FormattedMessage id="app.admin.all.order.table.status"
                                                  defaultMessage="Status"
                                                  description=""/>
                            </div>
                        </div>

                        <div className="col-md-2 all-order-center-align">
                            <FormattedMessage id="app.admin.all.order.table.action"
                                              defaultMessage="Actions"
                                              description=""/>
                        </div>
                        <hr/>
                    </div>

                </div>
            </div>
        )

    }
}

export default OrderTableHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewAllOrders/OrderTableHeader/OrderTableHeader.js